module.exports = __webpack_public_path__ + "static/gt-haptik-medium-500.latin-49d8ff34226b60f8880ac2924b443eb0.woff2";